var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedlnCrimson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52733 3C4.58757 3 3 4.58754 3 6.52733V17.4732C3 19.413 4.58754 21 6.52733 21H17.4732C19.413 21 21 19.413 21 17.4732V6.52733C21 4.58757 19.413 3 17.4732 3H6.52733ZM7.4145 5.97036C8.34457 5.97036 8.91746 6.58094 8.93514 7.38353C8.93514 8.1684 8.34454 8.79614 7.39651 8.79614H7.37906C6.46669 8.79614 5.87699 8.16844 5.87699 7.38353C5.87699 6.58095 6.48454 5.97036 7.41448 5.97036H7.4145ZM15.4294 9.72158C17.2181 9.72158 18.559 10.8907 18.559 13.403V18.0932H15.8407V13.7175C15.8407 12.6179 15.4473 11.8678 14.4635 11.8678C13.7125 11.8678 13.2649 12.3734 13.0683 12.8618C12.9965 13.0366 12.9789 13.2806 12.9789 13.5251V18.0932H10.2606C10.2606 18.0932 10.2962 10.6809 10.2606 9.9134H12.9795V11.0717C13.3407 10.5144 13.9869 9.72156 15.4294 9.72156V9.72158ZM6.03733 9.914H8.75567V18.0932H6.03733V9.914Z",
    fill: "#AB54A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedlnCrimson);
export default __webpack_public_path__ + "static/media/linkedln-crimson.bedf4cc800aa5cf6001e934704d3906a.svg";
export { ForwardRef as ReactComponent };